export function getWordCount(text) {
    text = text.trim();
    return text.length > 0 ? text.split(/\s+/).filter(value => !/^[!-\/:-@[-`{-~]+$/.test(value)).length : 0;
}
export function getCharacterCount(text) {
    return text.replace(/\n$/, "").length;
}
export function getReadingTime(text) {
    return getProcessingTime(text, 265);
}
export function getSpeakingTime(text) {
    return getProcessingTime(text, 150);
}
function getProcessingTime(text, wordsPerMinute) {
    // If empty, processing takes 0 seconds
    if (!text.trim())
        return 0;
    // Otherwise, at least 1 second
    return Math.max(Math.round(getWordCount(text) / wordsPerMinute * 60), 1);
}
